"use client";

import { ActivityDisplayPreview } from "./previews";

// ──────────────────────────────────────────────────────────────────────────────
// DISPLAY COMPONENT
// ──────────────────────────────────────────────────────────────────────────────

type SwimmingDisplayProps = {
  data: Record<string, unknown> | null;
  participants: {
    id: string;
    displayName: string;
    avatarUrl: string | null;
    username: string | null;
  }[];
};

export function SwimmingDisplay({ data, participants }: SwimmingDisplayProps) {
  return (
    <ActivityDisplayPreview
      activityId="swimming"
      data={data}
      participants={participants}
    />
  );
}
